import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=24aa99da&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=24aa99da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Spinner.vue').default,Empty: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Empty.vue').default,Well: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Well.vue').default})
